export const resolveUrl = url =>
  process.env.NODE_ENV !== 'production'
    ? `${process.env.NEXT_PUBLIC_BASE_URL}/${url}`
    : url;
